<template>
  <h3 v-if="count !== null && !loading" class="text-body-2 text-neutral600">
    <!-- `tc` injects its second argument as the `count` named param, so the
         message can reference both {count} and {filteredCount}. -->
    <span v-if="hasActiveFilters">{{ tc(keys.filtered, count, { filteredCount }) }}</span>
    <span v-else>{{ tc(keys.total, count) }}</span>
  </h3>
  <v-skeleton-loader v-else max-width="300" type="text" />
</template>

<script setup>
import { computed } from 'vue'

import { useTranslation } from '@/composables/useTranslation'
import { COUNT_SUBTITLE_KEYS, COUNT_SUBTITLE_RESOURCE } from '@/utils/constants'

const props = defineProps({
  resource: {
    type: String,
    required: true,
    validator: value => Object.values(COUNT_SUBTITLE_RESOURCE).includes(value),
  },
  // Total ignoring any active search/filter. `null` renders the skeleton.
  count: {
    type: Number,
    default: null,
  },
  // Number of results matching the active search/filter.
  filteredCount: {
    type: Number,
    default: null,
  },
  hasActiveFilters: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
})

const { tc } = useTranslation()

const keys = computed(() => COUNT_SUBTITLE_KEYS[props.resource])
</script>
